import {combineReducers} from "redux";
import auth from "./auth"
import person from "./person"
import customer from "./customer"
import site from "./site"
import lov from "./lov"
import selection from "./selection"
import lovManage from "./lovManage"
import selection_builder from "./selection_builder"
import importStatistics from "./import"

const RESET = "RESET";

const appReducer = combineReducers({
    auth, person, site, customer, lov, selection, importStatistics, lovManage, selection_builder
});

const rootReducer = (state, action) => {
    if (action.type === RESET) state = undefined;
    return appReducer(state, action);
};


export default rootReducer


// WEBPACK FOOTER //
// ./src/js/reducers/index.js